import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _CommercialCampaign, _DistributionChannel, _FreightRate, _TransportDestination, _TransportRoute } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorTransportRoute = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_TransportRoute)
    const paginador = usePaginator();

    const [id, setID] = useState(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const [text, setText] = useState<string>("")

    const modal = useModal("Rutas de Transporte", MODAL_md);

    useEffect(() => {
        if (render) {
            setText(render)
        }
    }, [render])

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDTransportRoute == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                if (selectedItem.DataBeanProperties.IDTransportRoute) {
                    setText(selectedItem.DataBeanProperties.Route)
                }
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getTransportRouteCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Route = (user.DataBeanProperties.TransportDestinationOrigin ?? "") + "-" + (user.DataBeanProperties.TransportDestinationDestinity ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDTransportRoute', visible: true },
        { title: 'Ruta', property: 'Route', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Habilitada', property: 'Enabled', visible: true },
    ]

    return (
        <>
            <label>{label ?? "Ruta de Transporte"}</label>
            <span className='form-control cursor ifmodal' onClick={() => modal.open()}>{text.trim() ? text : "Seleccione ruta de transporte"}</span>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDTransportRoute); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}